/*
 * cart-upsell.js — Quick Cart upsell "Skvěle to doplní" behavior.
 * The markup is server-rendered by snippets/lv-cart-upsell.liquid inside
 * #CartDrawerBody, so every cart change re-renders it (assets/cart.js swaps
 * innerHTML — scripts do NOT re-execute there, hence document-level delegation
 * here). Two behaviors:
 *   - [data-lv-upsell-add]: AJAX /cart/add.js via a pristine iframe fetch
 *     (bypasses Appstle's window.fetch patch), then dispatch cart:refresh —
 *     the drawer refetches its section; at 2 lines the Liquid hides the upsell.
 *   - [data-lv-upsell-close]: hide for this browser session (sessionStorage);
 *     re-applied after every drawer re-render via the cart:updated re-dispatch.
 *     Skipped entirely in the theme editor (Shopify.designMode) so the section
 *     never looks broken to the merchant.
 */
(function () {
  'use strict';
  if (window.__lvCartUpsell) return;
  window.__lvCartUpsell = true;


  // Pristine fetch via a hidden same-origin iframe. Appstle monkey-patches
  // window.fetch and can inject/override the selling plan on cart writes, so we
  // bypass it to make our /cart/add.js land exactly as sent. about:blank has
  // no base URL, so we pass absolute URLs.
  var _cf = null;
  var _cw = null;
  function cleanFetch(url, opts) {
    try {
      if (!_cf) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        (document.body || document.documentElement).appendChild(f);
        _cw = f.contentWindow;
        _cf = _cw.fetch;
      }
      var abs = String(url).charAt(0) === '/' ? window.location.origin + url : url;
      return _cf.call(_cw, abs, opts);
    } catch (e) {
      return fetch(url, opts);
    }
  }

  // Dismissal lasts only until the NEXT drawer open: in-memory flag (no storage
  // — a page load naturally resets it too). While the drawer stays open, cart
  // changes re-render the strip, so the flag is re-applied on cart:updated
  // (cart.js re-dispatches it synchronously after each innerHTML swap).
  var dismissed = false;

  function applyDismissState() {
    if (window.Shopify && Shopify.designMode) return;
    if (!dismissed) return;
    document.querySelectorAll('[data-lv-upsell]').forEach(function (el) {
      el.hidden = true;
    });
  }
  document.addEventListener('cart:updated', applyDismissState);

  // Reset on drawer open: the theme's DrawerComponent toggles the [open]
  // attribute on #CartDrawer (show() adds it, hide() removes it) — watch the
  // closed -> open transition and un-hide the already-rendered strip.
  function watchDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d || d.__lvUpsellWatched) return;
    d.__lvUpsellWatched = true;
    var wasOpen = d.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = d.hasAttribute('open');
      if (isOpen && !wasOpen) {
        dismissed = false;
        document.querySelectorAll('[data-lv-upsell]').forEach(function (el) {
          el.hidden = false;
        });
      }
      wasOpen = isOpen;
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  watchDrawer();
  // The editor can replace the whole section node — re-attach lazily.
  document.addEventListener('cart:updated', watchDrawer);

  // -------------------------------------------------------------- add to cart
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lv-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;
    // localized error message, rendered by Liquid from the theme locales
    var upsellBox = btn.closest('[data-lv-upsell]');
    var errorMsg = (upsellBox && upsellBox.getAttribute('data-error-message')) || 'Produkt se nepodařilo přidat.';

    btn.setAttribute('aria-busy', 'true');
    cleanFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            throw new Error(j.description || j.message || errorMsg);
          });
        }
        return r.json();
      })
      .then(function () {
        // Drawer is already open — bare refresh (no {open:true}); the section
        // refetch re-runs the Liquid, which hides the upsell at 2 lines.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        alert(err && err.message ? err.message : errorMsg);
      });
  });

  // ------------------------------------------------------- session dismiss (×)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lv-upsell-close]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-lv-upsell]');
    if (box) box.hidden = true;
    if (window.Shopify && Shopify.designMode) return;
    dismissed = true;
  });
})();
